import { Card, CardContent } from "../ui/card";
import { TrendingUp, DollarSign } from "lucide-react";

export const PipelineStats = ({ stats, formatCurrency }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <Card className="bg-[#0F0F3D] border-[#1E1E5F]">
      <CardContent className="pt-6">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-[#42E695]/20 rounded-lg">
            <TrendingUp className="h-6 w-6 text-[#42E695]" />
          </div>
          <div>
            <p className="text-slate-400 text-sm">Oportunidades Activas</p>
            <p className="text-2xl font-bold text-white">{stats.total}</p>
          </div>
        </div>
      </CardContent>
    </Card>
    <Card className="bg-[#0F0F3D] border-[#1E1E5F]">
      <CardContent className="pt-6">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-[#03BEE4]/20 rounded-lg">
            <DollarSign className="h-6 w-6 text-[#03BEE4]" />
          </div>
          <div>
            <p className="text-slate-400 text-sm">MRR Potencial</p>
            <p className="text-2xl font-bold text-white">{formatCurrency(stats.totalMRR)}/mes</p>
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
);
